import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { YesNoComponent, getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, getPhotoCaptureContextId, photoCaptureResetContextAction, photoCaptureUpdateAttachmentDataSuccessAction, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureAttachmentInfo, photoCaptureUpdateAttachedArtifactIdSuccessAction, getPhotoCaptureAttachedArtifactIds, getShouldAllowMitchellIntelligent } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationAnswerList, getQuestionnaireEvaluationParentQuestionId } from "../../../domain/questionnaireEvaluation";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        answerList: getQuestionnaireEvaluationAnswerList(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        isMic: getShouldAllowMitchellIntelligent(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureResetContextAction,
        photoCaptureUpdateAttachmentDataSuccessAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    }, dispatch);
};
export const ConnectedYesNoComponent = connect(mapStateToProps, mapDispatchToProps)(YesNoComponent);
//# sourceMappingURL=ConnectedYesNoComponent.js.map